var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('iframe',{attrs:{"src":_vm.src,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }